module.exports = __webpack_public_path__ + "img/17da198.jpg";